import React from 'react';
import { styled } from '@compiled/react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import { token } from '@atlaskit/tokens';
import type { listOptions_softwareReleasesVersionDetailIssueList$key } from '@atlassian/jira-relay/src/__generated__/listOptions_softwareReleasesVersionDetailIssueList.graphql';
import { FiltersAsync } from './filters/async.tsx';
import { AsyncSortIssues } from './sorting/AsyncSortIssues.tsx';

interface Props {
	jiraVersion: listOptions_softwareReleasesVersionDetailIssueList$key;
}

export const ListOptions = ({ jiraVersion }: Props): React.JSX.Element => {
	const jiraVersionData = useFragment(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment listOptions_softwareReleasesVersionDetailIssueList on JiraVersion {
				...async_softwareReleasesVersionDetailIssueList_FiltersAsync
			}
		`,
		jiraVersion,
	);

	return (
		<Wrapper>
			<FiltersAsync jiraVersion={jiraVersionData} />
			<SortingWrapper>
				<AsyncSortIssues />
			</SortingWrapper>
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	height: '40px',
	minWidth: '0',
	position: 'sticky',
	top: 0,
	zIndex: 2,

	backgroundColor: token('elevation.surface'),
	paddingTop: token('space.200'),
	paddingBottom: token('space.200'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SortingWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
});
